import React from 'react';
import {connect} from "react-redux";
import {Redirect} from "react-router";

const withAuthRedirect = (Component) => {

  let RedirectComponent = (props) => {
    // todo old auth
    // if(props.token === false)
    if(props.token === null) return <Redirect to={'/logbook/auth'} />
    return <Component {...props} />
  }

  const mapStateToProps = (state) => ({
    token: state.authReducer.token
  })

  return connect(mapStateToProps, {})(RedirectComponent)

};

export default withAuthRedirect;
